<div class="col-md">
    <div class="card">
        <div class="card-body">
            <div class="text-center">
                <img src="../../../../assets/images/logo-bsf.png" alt="BSF LOGO">
            </div>
            <p> <b>ที่เขต</b> {{zone}} / ............</p>
            <p style="text-align: center;">{{today }}</p>
            <p> <b>เรื่อง</b> ขอส่งสัญญาค้ำประกันปี 25{{year.substr(0,2)}}/25{{year.substr(2,2)}}</p>
            <p> <b>เรียน</b> ฝ่ายกฏหมาย</p>
            <p>สิ่งที่แนบมาด้วย เอกสารสัญญาค้ำประกัน</p>

            <table class="table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>โควตา</th>
                        <th>ชื่อ - สกุล</th>
                        <th>วันที่บันทึก</th>
                        <th>หมายเหตุ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of takedata; index as i">
                        <td>{{i+1}}</td>
                        <td>{{item.fmcode}}</td>
                        <td>{{item.fmname}}</td>
                        <td>{{THtoLocal(item.dateupdate)}}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td colspan="2">เป็นจำนวน {{takedata.length}} ราย</td>
                    </tr>
                </tbody>
            </table>
            <p style="text-align: center; font-weight:bold;">ขอแสดงความนับถือ</p>
            <br><br><br>
            <p style="text-align: center; font-weight:bold;">ผู้จัดการเขตส่งเสริมที่ {{zone}}</p>
            <hr> <br> <br>

            <table style="width: 100%;">
                <tr style="text-align: center;">
                    <td>ลงชื่อ...................................................ผู้ส่ง</td>
                    <td>ลงชื่อ...................................................แผนกนิติกรรมสัญญา</td>
                </tr>
                <tr style="text-align: center;">
                    <td>(....................................................)</td>
                    <td>(....................................................)</td>
                </tr>
                <tr style="text-align: center;">
                    <td>............/............/............</td>
                    <td>............/............/............</td>
                </tr>
            </table>

            <!--<div class="row d-flex justify-content-between">
                <div class="col-md-4" style="text-align: center;">
                    <p> ลงชื่อ..........................ผู้ส่ง </p>
                    <p> ........./........./......... </p>
                </div>
                <div class="col-md-4" style="text-align: center;">
                    <p> ลงชื่อ........................ ผู้รับ </p>
                    <p> ........./........./......... </p>
                </div>
                <div class="col-md-4" style="text-align: center;">
                    <p> ลงชื่อ.........................ฝ่ายกฏหมาย </p>
                    <p> ........./........./......... </p>
                </div>
            </div>-->
        </div>
    </div>
</div>